export enum HCPArteKanbanColumnKeyEnum {
  ARTES_NAO_INICIADAS = 'ARTES_NAO_INICIADAS',
  ARTE_EM_ANDAMENTO = 'ARTE_EM_ANDAMENTO',
  REVISAO_CLIENTE = 'REVISAO_CLIENTE',
  ALTERACAO_EM_ANDAMENTO = 'ALTERACAO_EM_ANDAMENTO',
  APROVADO_FINAL = 'APROVADO_FINAL',
}

export interface IHCPArteSLAProfile {
  nome: string
  prazo_revisao_briefing_horas: number
  prazo_producao_horas: number
  prazo_alteracao_horas: number
}

export interface IHCPArteEtiqueta {
  id: number
  nome: string
  cor: string
}

export interface IHCPArteDesigner {
  id: number
  nome: string
}

export interface IHCPArteFluxo {
  id: number
  status: string
  status_legivel: string
  prazo_atual: string | null
  atrasado: boolean
  perfil_sla: IHCPArteSLAProfile
  criado_em: string
  atualizado_em: string
  etiquetas: IHCPArteEtiqueta[]
}

export interface IHCPArteProducao {
  producao_id: number
  produto: string
  tiragem: string
  ordem_de_servico: string
  etapa: string
  data_inicio: string
  prazo_producao: string
  finalizacao: string | null
}

export interface IHCPArteKanbanItem {
  fluxo: IHCPArteFluxo
  produto_pedido_id: number
  pedido_id: string
  arte_id: number
  numero: string
  cliente: string
  produto_nome: string
  tiragem: number
  ordem_de_servico: string | null
  tem_briefing: boolean
  tem_arte: boolean
  revisoes_pendentes: number
  alteracoes_aprovadas: number
  alteracoes_entregues: number
  link_arte_final: string
  designer: IHCPArteDesigner | null
  thumbnail_arte_final: string | null
  no_prazo_producao: boolean | null
  itens_pendentes: number
  producao: IHCPArteProducao | null
}

export interface IHCPArteKanbanColumn {
  key: HCPArteKanbanColumnKeyEnum
  title: string
  count: number
  items: IHCPArteKanbanItem[]
}

export interface IHCPArteKanbanResponse {
  columns: IHCPArteKanbanColumn[]
}

export interface IHCPArteKanbanPayload {
  // Reservado para filtros futuros
}

export interface IHCPArteKanbanColunaPayload {
  status: HCPArteKanbanColumnKeyEnum
  tem_os?: boolean
  itens_pendentes?: boolean
  page?: number
  page_size?: number
}

export interface IHCPArteKanbanColunaResponse {
  count: number
  next: string | null
  previous: string | null
  results: IHCPArteKanbanItem[]
}

// Additional interfaces for new endpoints
export interface ICreativeFlowSearchPayload {
  query?: string
  [key: string]: any
}

export interface IBriefing {
  id: number
  [key: string]: any
}

export interface IArt {
  id: number
  [key: string]: any
}

export interface IDesignerMetric {
  id: number
  nome: string
  [key: string]: any
}

export interface ITag {
  id: number
  nome: string
  cor: string
}
